
export const CANNED_REPORTS: Array<any> = [
  {
    title: '',
    active: false,
    collapsed: false,
    reports: [
      {
        title: 'Adult Content',
        active: false,
        icon: '/assets/images/icon-report.svg',
        filters: {
          adultContentRating: 'H'
        },
        mainFilters: {
          region: 'GLOBAL'
        }
      },
      {
        title: 'Violence Content',
        active: false,
        icon: '/assets/images/icon-report.svg',
        filters: {
          violenceContentRating: 'H'
        },
        mainFilters: {
          region: 'GLOBAL'
        }
      },
      {
        title: 'High IVT',
        active: false,
        icon: '/assets/images/icon-report.svg',
        filters: {
          givtSivtRate: '[0.1,1]'
        },
        mainFilters: {
          region: 'GLOBAL'
        }
      },
      {
        title: 'No Privacy Policy',
        active: false,
        icon: '/assets/images/icon-report.svg',
        filters: {
          hasPrivacyLink: 'F'
        },
        mainFilters: {
          region: 'GLOBAL'
        }
      },
      {
        title: 'No Ads',
        active: false,
        icon: '/assets/images/icon-report.svg',
        filters: {
          hasAds: 'F'
        },
        mainFilters: {
          region: 'GLOBAL'
        }
      },
      {
        title: 'Anonymous (WHOIS Info Hidden)',
        active: false,
        icon: '/assets/images/icon-report.svg',
        filters: {
          isPrivateDomain: 'T'
        },
        mainFilters: {
          region: 'GLOBAL'
        }
      }
    ]
  }
];
